module.exports = __webpack_public_path__ + "_assets/img/avatar-notfound.51d67446.svg";